<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
      @changeInvalid="
        initPager()
        ini()
      "
      @changeProductName="
        initPager()
        ini()
      "
    >
      <template #searchDetailArea>
        <div class="px-9 py-7">
          <v-row no-gutters>
            <v-col cols="5" class="mr-12">
              <InputFormNew
                v-model="searchDetailInfo.line1"
                :detail="searchDetail.line1"
                :rowHeight="inputFormStyle.rowHeight"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
              </InputFormNew>
            </v-col>
            <v-col cols="6" class="mr-9">
              <InputFormNew
                v-model="searchDetailInfo.line2"
                :detail="searchDetail.line2"
                :rowHeight="inputFormStyle.rowHeight"
                :titleCols="3"
                :contentsCols="7"
              >
              </InputFormNew>
            </v-col>
          </v-row>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :summary="summary"
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @rowDialogMethodCommon="rowDialogMethodCommon"
          @pageMove="ini"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>

    <!-- <SalesDetailDialog
      v-model="dialogs.salesDetail"
      title="注文詳細"
      width="80%"
      :recItems="dialogs.salesDetail.rowItems"
      :pageInfoData="dialogs.salesDetail.pageInfoData"
    >
      <template #shipHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </SalesDetailDialog> -->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { commonUtil, supplierUtil } from '@/util'

import { saleStatusHistory, stockMoveStatusHistory } from '@/config'

import detail from './detail'
import headers from './headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'
import mutationTypes from '@/store/mutationTypes'
import { i18n } from '@/main.js'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew
  },
  data: () => {
    return {
      pageTitle: i18n.tc('storage.storage_storage-move-history'),
      pagerKey: 'storageHistory',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: i18n.tc('storage.storage_not-show-invalid-storage-move')
      },
      searchDetailInfo: {
        line1: {
          registerDate: {
            start: commonUtil.getFirstDateOneMonthAgo(),
            end: commonUtil.getLastDateThisMonth()
          },
          shipDate: { start: '', end: '' },
          arrivedDay: { start: '', end: '' },
          status: {
            value: stockMoveStatusHistory.STATUS_SELECTBOX.NOT_COMPLETE,
            label:
              stockMoveStatusHistory.STATUS_HISTORY_LABEL_SELECTBOX.NOT_COMPLETE
          }
        },
        line2: {
          storage: {
            ship: {},
            loading: {}
          },
          stockMoveInfo: '',
          productInfo: {
            number: '',
            category: ''
          }
        }
      },

      summary: {},
      historyList: [],
      customerList: [],

      dialogs: {
        ship: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        },
        salesDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    this.initPager()
    this.ini()
  },
  methods: {
    ...mapActions('StockMove', ['getStockMoveListFromApi']),
    ...mapGetters('StockMove', ['getStockMoveListFromState']),
    ...mapActions('Common', ['setIsLoading']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),

    async ini() {
      this.setIsLoading(true)
      supplierUtil.getSupplier()

      const getList = await this.getHistoryFromApi()
      const isNoData = !Object.keys(getList).length

      this.historyList = isNoData
        ? []
        : getList
            .sort((a, b) => {
              const keyName = 'storageMoveId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
              return ele
            })
      this.setIsLoading(false)
    },

    formatObjectRequest(val) {
      return this.isObject(val) ? val.value : val
    },
    async getHistoryFromApi() {
      const line1 = this.searchDetailInfo.line1
      const line2 = this.searchDetailInfo.line2

      // API call
      const ret = await this.getStockMoveListFromApi({
        invalidStorageMoveDisplay: this.searchHeaderInfo.InvalidData ? 0 : 1,
        moveStartDate: commonUtil.nullEmptyFormatNull(line1.registerDate.start),
        moveEndDate: commonUtil.nullEmptyFormatNull(line1.registerDate.end),
        shipStartDate: commonUtil.nullEmptyFormatNull(line1.shipDate.start),
        shipEndDate: commonUtil.nullEmptyFormatNull(line1.shipDate.end),
        arrivalStartDate: commonUtil.nullEmptyFormatNull(
          line1.arrivedDay.start
        ),
        arrivalEndDate: commonUtil.nullEmptyFormatNull(line1.arrivedDay.end),
        shipStorage: commonUtil.nullEmptyFormatNull(line2.storage.ship.value),
        loadingStorage: commonUtil.nullEmptyFormatNull(
          line2.storage.loading.value
        ),
        status: line1.status ? line1.status.value : null,
        moveControlNumber: commonUtil.nullEmptyFormatNull(line2.stockMoveInfo),
        productNumber: commonUtil.nullEmptyFormatNull(line2.productInfo.number),
        productName: commonUtil.nullEmptyFormatNull(
          this.searchHeaderInfo.productName
        ),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line2.productInfo.category
        ),
        page: commonUtil.nullEmptyFormatNull(this.pageInfo[this.pagerKey].page)
        // TODO：在庫移動理由の検索項目が必要、デザインできたら実装予定
        // storageMoveReason: line2.,
      })

      const getList = this.getStockMoveListFromState()

      return getList
    },
    isObject(val) {
      return val && typeof val === 'object'
    },
    getPaymentStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.PAYMENT_STATUS
      switch (status.value) {
        case statusList.BEFORE_PAYMENT: {
          return 1
        }
        case statusList.AFTER_PAYMENT: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getShipStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.SHIP_STATUS
      switch (status.value) {
        case statusList.BEFORE_SHIP: {
          return 1
        }
        case statusList.AFTER_SHIP: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getSaleStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.COMPLETE_STATUS
      switch (status.value) {
        case statusList.BEFORE_COMPLETE: {
          return 1
        }
        case statusList.AFTER_COMPLETE: {
          return 2
        }
        case statusList.CANCEL: {
          return 3
        }
        default: {
          return null
        }
      }
    },

    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1 && !rec.compDate
    },

    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          this.ini()
          break
        }
        default:
          this.rowDialogMethodShip(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSet(type, rowItems, pageInfoData) {
      const dataInfo = this.dialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodShip(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSet(type, rowItems, pageInfoData)
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    }
  },
  computed: {
    ...mapGetters('UI', ['pageInfo'])
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.ini()
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
